import React, { useState } from "react";
import {
  AppBar,
  Tabs,
  Tab,
  Box,
  Typography,
  TextField,
  Paper
} from "@mui/material";

import InboxTab from "./tabs/InboxTab";
import DashboardTab from "./tabs/DashboardTab";
import SankalanTab from "./tabs/SankalanTab";
import PashukhadyaTab from "./tabs/PashukhadyaTab";
import AdvanceTab from "./tabs/AdvanceTab";
import DepositLedgerTab from "./tabs/DepositLedgerTab";
import OtherAdvance from "./tabs/OtherAdvance";
import BillingTab from "./tabs/BillingTab";

export default function PassbookPage() {
  // helper to format Date → "YYYY-MM-DD" for <input type="date">
  const formatDate = (date) => {
    return date.toISOString().split("T")[0];
  };

  // today
  const today = new Date();
  // for example, default fromDate = 7 days ago
  const defaultFrom = new Date();
  defaultFrom.setDate(today.getDate() - 7);

  const [activeTab, setActiveTab] = useState(0);
  const [fromDate, setFromDate] = useState(formatDate(defaultFrom));
  const [toDate, setToDate] = useState(formatDate(today));

  // Mock farmer info for now
  // const farmerUsername = localStorage.getItem("farmerUsername") || "F-B-3";
  // const farmerName = localStorage.getItem("farmerName") || "राम पाटील";
  const farmerData = JSON.parse(localStorage.getItem("farmerData"));
  console.log("फार्मर नाव:", farmerData.name); // "राम पाटील"
  const farmerUsername = farmerData.username || "F-B-3";
  const farmerName = farmerData.name || "उत्पादकाचे नाव";
  const DairyName = localStorage.getItem("DairyName") || "डेअरीचे नाव";

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Header */}
      <Paper
        elevation={2}
        sx={{
          p: 2,
          mb: 2,
          backgroundColor: "hsla(153, 81%, 74%, 0.73)",
          backgroundImage:
            "linear-gradient(45deg, #17dddad6, rgba(184, 222, 247, 0.5))",
          backgroundBlendMode: "multiply",
          border: "1px solid #4CAF50",
          borderRadius: 2
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          MilkPro - Passbook
        </Typography>
        <Typography
          variant="h6"
          fontWeight="bold"
          color="text.secondary"
          gutterBottom
        >
          Milk Supplier - Farmer App
        </Typography>
        {/* console.log("Farmer Data:", localStorage.getItem("farmerData"));  // Debugging line */}
        {/* <Typography variant="body1">कोड: {farmerUsername}</Typography>
        <Typography variant="body1">नाव: {farmerName}</Typography> */}

        {/* Date range inputs */}
        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
          <TextField
            type="date"
            label="From"
            InputLabelProps={{ shrink: true }}
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            size="small"
          />
          <TextField
            type="date"
            label="To"
            InputLabelProps={{ shrink: true }}
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            size="small"
          />
        </Box>
      </Paper>

      {/* Tabs */}
      <AppBar
        position="static"
        sx={{ backgroundColor: "hsla(239, 73%, 36%, 1.00)" }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="इनबॉक्स" sx={{ color: "white" }} />
          <Tab label="डॅशबोर्ड" sx={{ color: "white" }} />
          <Tab label="संकलन" sx={{ color: "white" }} />
          <Tab label="ठेव" sx={{ color: "white" }} />
          <Tab label="पशूखाद्य" sx={{ color: "white" }} />
          <Tab label="अॅडव्हान्स" sx={{ color: "white" }} />
          <Tab label="इतर जमा-नावे" sx={{ color: "white" }} />
          <Tab label="बिलिंग" sx={{ color: "white" }} />
        </Tabs>
      </AppBar>

      {/* Tab Content */}
      <Box sx={{ p: 2 }}>
        {activeTab === 0 && <InboxTab fromDate={fromDate} toDate={toDate} />}
        {activeTab === 1 && <DashboardTab fromDate={fromDate} toDate={toDate} />}
        {activeTab === 2 && <SankalanTab fromDate={fromDate} toDate={toDate} />}
        {activeTab === 3 && (
          <DepositLedgerTab fromDate={fromDate} toDate={toDate} />
        )}
        {activeTab === 4 && <PashukhadyaTab fromDate={fromDate} toDate={toDate} />}
        {activeTab === 5 && <AdvanceTab fromDate={fromDate} toDate={toDate} />}
        {activeTab === 6 && <OtherAdvance fromDate={fromDate} toDate={toDate} />}
        {/* {activeTab === 7 && <BillingTab fromDate={fromDate} toDate={toDate} />} */}
        {activeTab === 7 && (
          <BillingTab 
              username={farmerUsername} 
              fromDate={fromDate} 
              toDate={toDate} 
          />
        )}

      </Box>
    </Box>
  );
}
